import React from 'react';
import { Link } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';

import { AuthUserContext } from '../Session';
import SignOutButton from '../SignOut';
import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';


const Navigation = () => (
  <AuthUserContext.Consumer>
    {authUser =>
      authUser ? (
        <NavigationAuth authUser={authUser} />
      ) : (
        <NavigationNonAuth />
      )
    }
  </AuthUserContext.Consumer>
);

const NavigationAuth = ({ authUser }) => {
  return (
  <div className="NavBar-Box">
    <AppBar position="static">
      <Toolbar className="nav-position">
          <MenuItem><Link to={ROUTES.AVAILABILITY} className="menu-item">Availability</Link></MenuItem>
          <MenuItem><Link to={ROUTES.ACCOUNT} className="menu-item">Account</Link></MenuItem>
          {(!!authUser.roles && !!authUser.roles[ROLES.ADMIN]) && (
            <MenuItem><Link to={ROUTES.ADMIN} className="menu-item">Admin</Link></MenuItem>
          )}
        <SignOutButton />
      </Toolbar>
    </AppBar>
  </div>
);}

const NavigationNonAuth = () => (
  <div className="NavBar-Box">
    <AppBar position="static">
      <Toolbar className="nav-position">
        <MenuItem><Link to={ROUTES.SIGN_IN} className="menu-item">Sign In</Link></MenuItem>
      </Toolbar>
    </AppBar>
  </div>
);

export default Navigation;
